module.exports = __webpack_public_path__ + "media/assets/images/flags/nu-31b63cbc719e2337c8d4c49a2908c9ec.svg";